import { useMutation, UseMutationResult } from '@tanstack/react-query';
import adserver from 'services/adserver';
import { downloadBlob } from 'helpers/downloadFile';

type DownloadFileParams = {
  url: string;
  fileName: string;
  params?: Record<string, any>;
};

// adserver's baseURL already ends in `/api`, also direct Files urls have them
// dynamic file urls like reports are ok, but since files have /api prefix - those need to be removed
// to keep hook universal
const stripApiPrefix = (url: string): string =>
  url.replace(/^\/api(?=\/|$)/, '');

export const useDownloadFile = (): UseMutationResult<
  void,
  unknown,
  DownloadFileParams
> =>
  useMutation(async ({ url, fileName, params }: DownloadFileParams) => {
    const { data } = await adserver({
      url: stripApiPrefix(url),
      method: 'GET',
      headers: {},
      responseType: 'blob',
      params,
    });
    downloadBlob(data, fileName);
  });
